import axios from "axios";
import { IBiometryData } from "../reducers/biometryReducer";
import SaveBiometryResultRequest from "@config/types/requests/SaveBiometryResultRequest";
import Keys from "@utils/keys";
import { IStoreState } from "..";

const ROOT_URL = Keys.SERVICOS.API.ROOT_URL;

export const BIOMETRICS_ACTIONS = {
  REQUIRE: "BIOMETRICS/REQUIRE",
  FETCH_DATA: "BIOMETRICS/FETCH_DATA",
  REGISTER_RESULT: "BIOMETRICS/REGISTER_RESULT",
  CLEAR: "BIOMETRICS/CLEAR",
};

export const requireBiometrics = () => {
  return { type: BIOMETRICS_ACTIONS.REQUIRE, payload: true };
};

// export const fetchBiometrics = (data: IBiometricsData) => {
//   return { type: BIOMETRICS_ACTIONS.FETCH_DATA, payload: data };
// };

export const saveBiometrics = (data: IBiometryData) => {
  return async (
    dispatch: (arg0: { type: string }) => void,
    getState: () => IStoreState
  ) => {
    const body = new SaveBiometryResultRequest(
      data.card,
      getState().prestador.CPF_CNPJ,
      data.message,
      data.response
    );
    await axios.post(`${ROOT_URL}/Beneficiarios/biometria/salvar`, body);
    dispatch({ type: BIOMETRICS_ACTIONS.REGISTER_RESULT });
  };
};

export const clearBiometrics = () => {
  return { type: BIOMETRICS_ACTIONS.CLEAR };
};
